import Vue from 'vue'

export default async (page = 1, method = '', id = '') => {
  let res = await Vue.axios.get(`/billing/payments?page=${page}${method !== '' ? `&payment_gateway=${method}` : ''}${id !== '' ? `&transaction_id=${id}` : ''}`)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/fetch-payments.js